import { useMemo } from "react";
import { calculateSchedulePricing } from "../utils/schedulePricing.utils";

const useSchedulePricing = (schedules, voucherValid) => {
  return useMemo(
    () => calculateSchedulePricing(schedules, voucherValid),
    [schedules, voucherValid]
  );
};

export default useSchedulePricing;